import { Pages } from 'routes/types'
import { getCookie } from 'utils/cokie'

export const leadsTabs = ['Opportunities', 'Leads', 'In review', 'Being deployed']
export const comercials = ['Standard', 'Custom']
export const INDIVIDUALPANDOCSUBTYPE = 'INDIVIDUALPAN'
export const GSTDOCSUBTYPE = 'GST'
export enum AccountType {
  PETROLEUM = 'Petroleum',
  RETAIL = 'Retail Merchant',
}
export enum MerchantSignatoryType {
  PARTNER = 'PARTNER',
  DIRECTOR = 'DIRECTOR',
}

export const advancePaymentMode = [
  { key: '0', value: '3 months advance payment ' },
  { key: '1', value: '6 months advance payment ' },
]

export enum OwnershipType {
  PROPRIETORSHIP = 'PROPRIETORSHIP',
  PARTNERSHIP = 'PARTNERSHIP',
  COMPANY = 'COMPANY',
  FIRM = 'FIRM',
  LLP = 'LLP',
  PRIVATE_LIMITED_COMPANY = 'PRIVATE_LIMITED_COMPANY',
  PUBLIC_LIMITED_COMPANY = 'PUBLIC_LIMITED_COMPANY',
}

export const pricingPlans = [
  { key: '0', value: 'Rent waiver on 7.5 Lakh txns' },
  { key: '1', value: 'Rent waiver on 5 Lakh txns' },
]

export const leadWithStatus = {
  Opportunities: 'INITIATED',
  Leads: 'LEADS',
  In_review: 'IN_REVIEW ',
  Being_deployed: 'DEPLOYMENT_IN_PROGRESS',
  Live: 'LIVE',
  Lost: 'LOST',
  Rejected: 'Rejected',
  Training_And_Support: 'Training & Support',
  Store_Addresses: 'Store addresses',
  Revisits: 'Revisit',
}

export const LeadStatusV2 = {
  INITIATED: 'INITIATED',
  LEADS: 'LEADS',
  IN_REVIEW: 'IN_REVIEW ',
  DEPLOYMENT_IN_PROGRESS: 'DEPLOYMENT_IN_PROGRESS',
  LIVE: 'LIVE',
  LOST: 'LOST',
  REJECTED: 'Rejected',
  TRAING_SUPPORT: 'Training & Support',
  STORE_ADDRESS: 'Store addresses',
  REVISITS: 'Revisit',
}

export const getStatusList = (leadStatus: string): Array<string> => {
  if (leadStatus === LeadStatusV2.INITIATED) {
    return ['INITIATED', 'PRICING_SUBMITTED', 'PRICING_APPROVED', 'PO_ACTIVATION_APPROVED']
  } else if (leadStatus === LeadStatusV2.IN_REVIEW) {
    return ['DEPLOYMENT_REQUESTED', 'PO_ACTIVATION_REQUESTED']
  } else if (leadStatus === LeadStatusV2.REJECTED) {
    return ['PRICING_REJECTED', 'PO_ACTIVATION_REJECTED', 'DEPLOYMENT_REJECTED']
  } else if (leadStatus === LeadStatusV2.DEPLOYMENT_IN_PROGRESS) {
    return ['DEPLOYMENT_APPROVED', 'DEPLOYMENT_COMPLETED']
  }
  return []
}

export enum kycCaptureType {
  SELFIE,
  STOCK,
  SHOP,
  OPERATINGLICENSE,
  STATEMENT,
}

interface SortOption {
  label: string
  value: string
}

export const filterData = ['Today', 'Yesterday', '7 days']

export const sortData: Readonly<SortOption[]> = [
  { label: 'Date created', value: 'createdAt' },
  { label: 'Lead rating', value: 'rating' },
  { label: 'Next scheduled', value: 'scheduledFollowUp' },
]

export const sortDataForRevisit: Readonly<SortOption[]> = [
  { label: 'Latest First ↑', value: 'DESC' },
  { label: 'Oldest First ↓', value: 'ASC' },
]

export const sortOrder = ['DESC', 'ASC']

export const oppSortData = [
  { label: 'Lead rating', value: 'Lead rating' },
  { label: 'Date created', value: 'Date created' },
]

export const mandateTypes = ['E-mandate', 'Physical']
export const restrictedMcc = [
  1409, 1520, 3351, 3747, 4511, 4813, 4816, 4829, 5039, 5122, 5413, 5531, 5542, 5599, 5818, 5932,
  5933, 5937, 5963, 5965, 5966, 5967, 5968, 5969, 5972, 5993, 6010, 6011, 6012, 6050, 6051, 6211,
  6513, 6529, 6531, 6533, 6538, 6540, 7012, 7273, 7277, 7297, 7299, 7311, 7322, 7339, 7361, 7375,
  7409, 7800, 7801, 7802, 7829, 7994, 7995, 7996, 8398, 8641, 8651, 8661, 8675, 8734, 8999, 9211, 9222,
  9223, 9700, 9405,
]
export const petroleumMccs = [5542, 5541, 5983, 5172]

export const specialMccList = (isMini: boolean) => {
  if (isMini) {
    return [5921, 5912, 5813]
  }
  return [4722, 5921, 5912, 5813]
}

export const specialMccLicenseMapping = {
  '5962': 'IATA/IATO Certificate',
  '4722': 'IATA/IATO Certificate',
  '5921': 'Liquor License',
  '5912': 'Drug License/Ayush License',
  '8220': 'UGC certificate/ICSE/CBSE/AICTE',
  '8211': 'UGC certificate/ICSE/CBSE/AICTE',
  '5812': 'FSSAI License',
  '5813': 'Liquor License',
  '5814': 'FSSAI License',
}
export const KYCDETAILSDOCTYPE = 'PROOFOFIDENTITY'
export const GSTDOCTYPE = 'BUSINESSLEGALITYPROOF'
export const CAPTUREPHOTODOCSUBTYPE = 'NA'

export enum nachMandateDocType {
  PANCARD,
  SIGNEDFORM,
  CHEQUE,
  AMT_EMAIL_EMAIL,
}

export enum otherBusinessDocType {
  DEED,
  BENIFICARY,
}

export enum imageSources {
  GALLERY = 'DOCUMENTUPLOAD',
  CAMERA = 'LIVEPHOTO',
}

export const mandateStatusMessage = {
  acknowledged: 'Mandate submitted. waiting for Mandate Activation',
  active: 'Mandate successfully activated',
  failed: 'Mandate activation failed',
  cancelled: 'Mandate cancelled',
  expired: 'Mandate expired',
  pending_no_error: 'Mandate not yet submitted',
  pending_error: 'Mandate registration failed',
  submitted: 'Mandate submitted. waiting for Mandate Activation',
  withdrawn: 'Mandate withdrawn',
  pending_submission: 'Mandate not yet submitted',
}
export enum deploymentStatus {
  SUBMITTED = 'SUBMITTED',
  NOTSUBMITTED = 'NOTSUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum opportunityStatus {
  INITIATED = 'INITIATED',
  PRICING_SUBMITTED = 'PRICING_SUBMITTED',
  PRICING_APPROVED = 'PRICING_APPROVED',
  PRICING_REJECTED = 'PRICING_REJECTED',
  PO_APPROVAL_SUBMITTED = 'PO_APPROVAL_SUBMITTED',
  CSE_APPROVED = 'CSE_APPROVED',
  CSE_REJECTED = 'CSE_REJECTED',
  DEPLOYMENT_REQUESTED = 'DEPLOYMENT_REQUESTED',
  DEPLOYMENT_APPROVED = 'DEPLOYMENT_APPROVED',
  DEPLOYMENT_REJECTED = 'DEPLOYMENT_REJECTED',
  PO_ACTIVATION_REJECTED = 'PO_ACTIVATION_REJECTED',
  PO_ACTIVATION_APPROVED = 'PO_ACTIVATION_APPROVED',
  PO_ACTIVATION_REQUESTED = 'PO_ACTIVATION_REQUESTED',
}

export enum poActivationStatus {
  APPROVED = 'Approved',
  AUTO_APPROVED = 'Auto Approved',
  REJECTED = 'Rejected',
  SUBMITTED = 'Submitted',
  REVIEW = 'Review in Progress',
}

export const is3PAgentLoggedIn = () => {
  return getCookie('user_type')?.toLowerCase() === 'powerpartner'
}

export enum OnboardingMode {
  INSTANT = 'instant',
  FSR = 'fsr',
}

const ONBOARDING_MODE_STORAGE_KEY = 'onboarding_mode'
const ONBOARDING_MODE_OPP_ID_STORAGE_KEY = 'onboarding_mode_opp_id'

export const getOnboardingMode = () => {
  const onboardingMode = localStorage.getItem(ONBOARDING_MODE_STORAGE_KEY)
  const selectedOppId = localStorage.getItem('oppId')
  const onboardingModeOppId = localStorage.getItem(ONBOARDING_MODE_OPP_ID_STORAGE_KEY)

  if (onboardingMode && (!selectedOppId || onboardingModeOppId === selectedOppId)) {
    return onboardingMode
  }

  if (onboardingMode && selectedOppId && onboardingModeOppId !== selectedOppId) {
    setOnboardingMode(null)
  }

  return null
}

export const setOnboardingMode = (onboardingMode?: string | null, oppId?: string | number | null) => {
  const selectedOppId = oppId ? String(oppId) : localStorage.getItem('oppId') || ''
  if (onboardingMode) {
    localStorage.setItem(ONBOARDING_MODE_STORAGE_KEY, onboardingMode)
    localStorage.setItem(ONBOARDING_MODE_OPP_ID_STORAGE_KEY, selectedOppId)
  } else {
    localStorage.removeItem(ONBOARDING_MODE_STORAGE_KEY)
    localStorage.removeItem(ONBOARDING_MODE_OPP_ID_STORAGE_KEY)
  }
}

export const setOpportunityOnboardingMode = (opportunityData?: any | null) => {
  const opportunity = opportunityData?.opportunity ?? opportunityData
  const opportunityId = opportunity?.id
  const onboardingMode = opportunity?.onboardingMode ?? null

  if (!opportunityId) {
    return
  }

  if (String(opportunityId) === localStorage.getItem('oppId')) {
    setOnboardingMode(onboardingMode, opportunityId)
  }
}

export const isMiniFlow = () => {
  const onboardingMode = getOnboardingMode()?.toLowerCase()
  if (!onboardingMode) {
    return localStorage.getItem('opty_owner') === 'StandardMini' || is3PAgentLoggedIn()
  }
  if (onboardingMode === OnboardingMode.FSR) {
    return false
  }
  if (onboardingMode === OnboardingMode.INSTANT) {
    return true
  }
  return localStorage.getItem('opty_owner') === 'StandardMini' || is3PAgentLoggedIn()
}

export enum DeploymentTypeSelection {
  SELF_DEPLOYMENT = 'SELF_DEPLOYMENT',
  DEPLOYMENT_BY_FSR = 'DEPLOYMENT_BY_FSR',
}

export const isInstantOnboardingFlow = () => {
  return getOnboardingMode()?.toLowerCase() === OnboardingMode.INSTANT || isMiniFlow()
}

export const productInterestList = () => {
  const list = []
  list.push({ key: 0, label: 'POS Device', value: 'POS_DEVICE', selected: false })
  list.push({ key: 1, label: 'Voice Pod', value: 'VOICEPOD', selected: false })
  list.push({ key: 2, label: 'SQR Mini', value: 'SQR_MINI', selected: false })
  list.push({ key: 3, label: 'DQR Mini', value: 'DQR_MINI', selected: false })
  list.push({ key: 4, label: 'Voice Pod Pro', value: 'VOICEPOD_PRO', selected: false })
  return list
}

export const miniProductsList = ['SQR_MINI', 'DQR_MINI']

export const GSTCODEANDSTATEMAPPING = {
  '01': 'JK',
  '02': 'HP',
  '03': 'PJ',
  '04': 'CG',
  '05': 'UC',
  '06': 'HR',
  '07': 'DL',
  '08': 'RJ',
  '09': 'UP',
  '10': 'BI',
  '11': 'SK',
  '12': 'AR',
  '13': 'NG',
  '14': 'MN',
  '15': 'MZ',
  '16': 'TR',
  '17': 'MG',
  '18': 'AS',
  '19': 'WB',
  '20': 'JH',
  '21': 'OR',
  '22': 'CH',
  '23': 'MP',
  '24': 'GJ',
  '26': 'DN',
  '27': 'MH',
  '28': 'AP',
  '29': 'KT',
  '30': 'GA',
  '31': 'LD',
  '32': 'KR',
  '33': 'TN',
  '34': 'PY',
  '35': 'AN',
  '36': 'TG',
  '37': 'AP',
  '38': 'LA',
}

export const ReasonsNotConverted = [
  { key: 0, label: 'High Commercials' },
  { key: 1, label: 'Merchant Not Reachable' },

  { key: 2, label: 'Instant Settlement Required' },
  { key: 3, label: 'On Hold' },
  { key: 4, label: 'Not Interested' },
]

export const LeadFilterData = {
  leadStatus: [
    { label: 'New', value: 'NEW' },
    { label: 'Open - Contacted', value: 'OPEN_CONTACTED' },
    { label: 'Open - Not Contacted', value: 'OPEN_NOT_CONTACTED' },
    { label: 'Closed - Converted', value: 'CLOSED' },
    { label: 'Closed - Not Converted', value: 'LOST' },
    { label: 'Qualified', value: 'QUALIFIED' },
    { label: 'Contacted (IS)', value: 'CONTACTED' },
    { label: 'Assign to retail', value: 'ASSIGN_TO_RETAIL' },
    { label: 'Work In Progress', value: 'WORK_IN_PROGRESS' },
  ],
  contactStatus: [
    { label: 'Not Approached', value: 'Not Approached' },
    { label: 'Approached', value: 'Approached' },
  ],
  leadSource: [
    { label: 'AllTap', value: 'ALLTAP' },
    { label: 'Amazon', value: 'AMAZON' },
    { label: 'AU Bank', value: 'AU_BANK' },
    { label: 'Bank', value: 'BANK' },
    { label: 'Bank Lead', value: 'BANK_LEAD' },
    { label: 'Brand EMI Activation Team', value: 'BRAND_EMI_ACTIVATION_TEAM' },
    { label: 'Chatbot', value: 'CHATBOT' },
    { label: 'CSB-Bank', value: 'CSB_BANK' },
    { label: 'Customer Delight Team', value: 'CUSTOMER_DELIGHT_TEAM' },
    { label: 'Customer Referral', value: 'CUSTOMER_REFERRAL' },
    { label: 'Customer Support Team', value: 'CUSTOMER_SUPPORT_TEAM' },
    { label: 'Dhanlaxmi Bank', value: 'DHANLAXMI_BANK' },
    { label: 'Dlocal L2L', value: 'DLOCAL_L2L' },
    { label: 'DSA', value: 'DSA' },
    { label: 'Emailers', value: 'EMAILERS' },
    { label: 'EMI Welcome Team', value: 'EMI_WELCOME_TEAM' },
    { label: 'Enterprise', value: 'ENTERPRISE' },
    { label: 'EPOS', value: 'EPOS' },
    { label: 'Epos Controller', value: 'EPOS_CONTROLLER' },
    { label: 'Facebook', value: 'FACEBOOK' },
    { label: 'FB Ad posts', value: 'FB_AD_POSTS' },
    { label: 'Google ads', value: 'GOOGLE_ADS' },
    { label: 'HDFC', value: 'HDFC' },
    { label: 'HDFC GPRS', value: 'HDFC_GPRS' },
    { label: 'HUL', value: 'HUL' },
    { label: 'Lead Generation Partner', value: 'LEAD_GENERATION_PARTNER' },
    { label: 'Lending Lead', value: 'LENDING_LEAD' },
    { label: 'Linkedin', value: 'LINKEDIN' },
    { label: 'LMS Leads', value: 'LMS_LEAD' },
    { label: 'MDA', value: 'MDA' },
    { label: 'Marketing Team', value: 'MARKETING_TEAM' },
    { label: 'Merchant Lending', value: 'MERCHANT_LENDING' },
    { label: 'One App', value: 'ONE_APP' },
    { label: 'One Web', value: 'ONE_WEB' },
    { label: 'Other', value: 'OTHER' },
    { label: 'Paygoal', value: 'PAYGOAL' },
    { label: 'PayGlcoal Domestic', value: 'PAYGLCOAL_DOMESTIC' },
    { label: 'PayGlcoal Domestic+international', value: 'PAYGLCOAL_DOMESTIC_INTERNATIONAL' },
    { label: 'PL Website', value: 'PL_WEBSITE' },
    { label: 'PL Website PPC', value: 'PL_WEBSITE_PPC' },
    { label: 'Plutus Support Call Center', value: 'PLUTUS_SUPPORT_CALL_CENTER' },
    { label: 'Qfix', value: 'QFIX' },
    { label: 'Retail Sales Team', value: 'RETAIL_SALES_TEAM' },
    { label: 'Sales app', value: 'SALES_APP' },
    { label: 'Self generated', value: 'SELF_GENERATED' },
    { label: 'Self Serv', value: 'SELF_SERV' },
    { label: 'Service Engineer Team', value: 'SERVICE_ENGINEER_TEAM' },
    { label: 'SF', value: 'SF' },
    { label: 'SMS Campaigns', value: 'SMS_CAMPAIGNS' },
    { label: 'SMB', value: 'SMB' },
    { label: 'Twitter', value: 'TWITTER' },
    { label: 'Web To Lead', value: 'WEB_TO_LEAD' },
    { label: 'Website', value: 'WEBSITE' },
    { label: 'Welcome Team', value: 'WELCOME_TEAM' },
    { label: 'Whatsapp', value: 'WHATSAPP' },
  ],
}
export enum CurrentStatus {
  Prospecting = 'Prospecting',
  Approach = 'Approach',
  Demo = 'Demo',
  Evaluation = 'Evaluation',
  Commitment_To_Purchase = 'Commitment_To_Purchase',
  Sales_Closed = 'Sales_Closed',
  Null_CurrentStatus = 'Null_CurrentStatus',
}

export enum PushToSFStage {
  STAGE1 = 'STAGE1',
  STAGE2 = 'STAGE2',
  STAGE3 = 'STAGE3',
  STAGE4 = 'STAGE4',
  STAGE5 = 'STAGE5',
  STAGE5_INT = 'STAGE5_INT',
  STAGE6 = 'STAGE6',
  OPPORTUNITY = 'OPPORTUNITY',
  LEAD = 'LEAD',
  BO = 'BO',
  VAS_ACTIVATION = 'VAS_ACTIVATION_OPTI_AND_OLI_SYNC',
  REVIEW_VAS_OPTI = 'REVIEW_VAS_OPTI',
  ASSET_V2 = 'ASSET2',
}
